import React, { useState } from 'react';
import { Certification } from '../../entities/Certification';
import './ProductCertifications.scss';
import ProductCertificationsItems from './ProductCertificationsItems';
interface ProductCertificationsProps {
  productTitle: string;
  certifications: Array<Certification>;
}

export default function ProductCertifications({ certifications, productTitle }: ProductCertificationsProps): React.ReactElement {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  if (certifications.length === 0) return null;

  // Group certifications by name
  const groupedCertifications = certifications.reduce(
    (acc, cert) => {
      if (!acc[cert.name]) acc[cert.name] = [];
      acc[cert.name].push(cert);
      return acc;
    },
    {} as Record<string, Certification[]>
  );

  return (
    <div className="product-certifications">
      <h4>Certifications</h4>
      <ProductCertificationsItems
        productTitle={productTitle}
        certificationsGroup={groupedCertifications}
        openIndex={openIndex}
        setOpenIndex={setOpenIndex}
      />
    </div>
  );
}
